import * as React from "react";
import { Apps28Regular, Apps28Filled } from "@fluentui/react-icons";

import { TeamAppConfig } from "Apps/TeamAppModel";

const IC3IEGApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "IC3IEG" */ "./IC3IEGApp");
    return { default: namedExport.IC3IEGApp };
});

export const IC3IEG: TeamAppConfig = {
    title: "IC3 Impact Event Graph (IEG)",
    regularIcon: Apps28Regular,
    filledIcon: Apps28Filled,
    description: "The IC3 Impact Event Graph is a platform designed to diagnose IC3 incidents and provide recommendations of potential root causes for OCEs",
    team: "IC3",
    publicId: "IC3IMPACTGRAPH\\Triage",
    owner: "ic3-impactgraph-crew@microsoft.com",
    role: "*",
    tags: [],
    app: IC3IEGApp,
    path: "/IC3/ImpactEventGraph"
};
